import React from 'react';
import { Header, Icon } from 'semantic-ui-react';

const LoginError = ({ onClickRetry }) => (
  <Header as="h3" color="grey">
    <Icon name="warning sign" />
    <Header.Content>Error Authenticating</Header.Content>
  </Header>
);

export default LoginError;
